/**
 * # ModalInstanceCtrl
 * Controller of the coreModule
 */
angular
  .module('coreModule')
  .controller('ModalInstanceCtrl', function ($uibModalInstance, items) {
    const $ctrl = this;
    $ctrl.items = items;
    $ctrl.selected = {
      item: $ctrl.items[0],
    };

    $ctrl.ok = () => {
      $uibModalInstance.close($ctrl.selected.item);
    };

    $ctrl.cancel = () => {
      $uibModalInstance.dismiss('cancel');
    };
  });
